import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Bed = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="bed icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 20C3.55229 20 4 20.4477 4 21L4 43C4 43.5523 3.55228 44 3 44C2.44772 44 2 43.5523 2 43L2 21C2 20.4477 2.44772 20 3 20Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 38V44C46 44.5523 45.5523 45 45 45C44.4477 45 44 44.5523 44 44V39H3C2.44772 39 2 38.5523 2 38C2 37.4477 2.44772 37 3 37H45C45.5523 37 46 37.4477 46 38Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 27.6768V38C46 38.5523 45.5523 39 45 39C44.4477 39 44 38.5523 44 38V27.6768C44 27.3065 43.8067 27.0565 43.5693 26.9667C41.7783 26.2888 37.3436 25 29.5 25H15.9998C15.4477 25 15 25.4476 15 26L15 38C15 38.5523 14.5523 39 14 39C13.4477 39 13 38.5523 13 38L13 26C13 24.3433 14.3428 23 15.9998 23H29.5C37.5668 23 42.2433 24.3263 44.2772 25.0962C45.3984 25.5205 46 26.5945 46 27.6768Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 31C2 30.4477 2.44772 30 3 30H14C14.5523 30 15 30.4477 15 31C15 31.5523 14.5523 32 14 32H3C2.44772 32 2 31.5523 2 31Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 24C19.5523 24 20 24.4477 20 25V38C20 38.5523 19.5523 39 19 39C18.4477 39 18 38.5523 18 38V25C18 24.4477 18.4477 24 19 24Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9.5C18 7.84315 19.3431 6.5 21 6.5H23C24.6569 6.5 26 7.84315 26 9.5V13.4296C26 14.4327 25.4987 15.3694 24.6641 15.9258L23.6641 16.5925C22.6564 17.2642 21.3436 17.2642 20.3359 16.5925L19.3359 15.9258C18.5013 15.3694 18 14.4327 18 13.4296V9.5ZM21 8.5C20.4477 8.5 20 8.94772 20 9.5V13.4296C20 13.764 20.1671 14.0762 20.4453 14.2617L21.4453 14.9283C21.7812 15.1523 22.2188 15.1523 22.5547 14.9283L23.5547 14.2617C23.8329 14.0762 24 13.764 24 13.4296V9.5C24 8.94772 23.5523 8.5 23 8.5H21Z"
    />
    <path
      className={pathClass}
      d="M19 11.5H25V13.6776C25 13.9862 24.8575 14.2775 24.6139 14.4669L22.6139 16.0225C22.2528 16.3034 21.7472 16.3034 21.3861 16.0225L19.3861 14.4669C19.1425 14.2775 19 13.9862 19 13.6776V11.5Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.5 23C8.11929 23 7 24.1193 7 25.5C7 26.8807 8.11929 28 9.5 28C10.8807 28 12 26.8807 12 25.5C12 24.1193 10.8807 23 9.5 23ZM5 25.5C5 23.0147 7.01472 21 9.5 21C11.9853 21 14 23.0147 14 25.5C14 27.9853 11.9853 30 9.5 30C7.01472 30 5 27.9853 5 25.5Z"
    />
    <path
      className={pathClass}
      d="M2 30C2 28.8954 2.89543 28 4 28H10C11.1046 28 12 28.8954 12 30C12 31.1046 11.1046 32 10 32H4C2.89543 32 2 31.1046 2 30Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 4C21 3.44772 21.4477 3 22 3H28C28.5523 3 29 3.44772 29 4V21C29 21.5523 28.5523 22 28 22C27.4477 22 27 21.5523 27 21V5H23V6.55C23 7.10228 22.5523 7.55 22 7.55C21.4477 7.55 21 7.10228 21 6.55V4Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 13.5C22.5523 13.5 23 13.9477 23 14.5C23 16.895 22.8501 19.1026 22.3671 20.9386C21.8832 22.7781 21.0339 24.3589 19.5496 25.3354C19.0882 25.639 18.4681 25.511 18.1646 25.0496C17.861 24.5882 17.989 23.9681 18.4504 23.6646C19.3661 23.0621 20.0168 22.0113 20.4329 20.4298C20.8499 18.8448 21 16.8418 21 14.5C21 13.9477 21.4477 13.5 22 13.5Z"
    />
  </svg>
)
